import { render, staticRenderFns } from "./RouterOutView.vue?vue&type=template&id=2faf66c0"
import script from "./RouterOutView.vue?vue&type=script&lang=ts"
export * from "./RouterOutView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2faf66c0')) {
      api.createRecord('2faf66c0', component.options)
    } else {
      api.reload('2faf66c0', component.options)
    }
    module.hot.accept("./RouterOutView.vue?vue&type=template&id=2faf66c0", function () {
      api.rerender('2faf66c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RouterOutView.vue"
export default component.exports